module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "x-SECTION-BREAK"
  }), _vm._v(" "), _c('p', {
    staticClass: "x1CHAP-NUM",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#toc_marker-3"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "x1BM-FIRST"
  }, [_c('span', {
    staticClass: "Initial-Cap-Italic"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("he surface of the Abyss was covered with an immense desert that had once been a fathomless ocean. It was a place of glistening black sand, venomous beasts, creeping vermin, and of course the Abyssi—­those perfect, beautiful predators who ruled the infernal realm by fang and claw.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1BM"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("One such creature looked past the gray, smoky sky above him to a realm where the ocean was cold and tasted of salt, where verdant green cascaded across rich earth, and where the mortal creatures lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1BM"
  }, [_vm._v("Soon"), _c('span', {
    staticClass: "Italic"
  }, [_vm._v(", thought the Abyssi.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1BM"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("It was a powerful thought, for one of his kind. Most Abyssi had no concept of ")]), _vm._v("soon"), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("; they could only consider ")]), _vm._v("now"), _c('span', {
    staticClass: "Italic"
  }, [_vm._v(", and whether what stood before them could be devoured or enjoyed in other ways. They certainly did not have the patience to create a mancer, an effort that took many careful years siphoning power into one of the frail creatures of the mortal realm. A mancer who would—­soon—­be able to break the barrier that separated this world from the one before it.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1BM"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("In the mortal world, the creatures who considered themselves strongest had nearly no fur. Their teeth were dull as if for grinding grass, and their nails were short and rounded, useless for shredding flesh. In the mortal world, the Abyssi would play.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c87056d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 69
// module chunks = 0